import GenericDB from './generic-db';

export default class ClinicSettingsUpdatesDB extends GenericDB {
  constructor() {
    super('clinicSettingsUpdates');
  }
}
